import React, { useEffect, useState } from "react";
import LoadingStatus from "../../Components/PolicyStatusComponents/LoadingStatus";
import SuccesStatus from "../../Components/PolicyStatusComponents/SuccesStatus";
import Axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import PolicyNum from "../../Components/PolicyStatusComponents/PolicyNum";

const indicatorSize = 80;

const HealthInsPolicyStatus = () => {
  const [loading, setLoading] = useState(true);
  const [rejectPolicy, setRejectPolicy] = useState(true);
  const [policyData, setPolicyData] = useState({});

  const [policyDeclined, setPolicyDeclined] = useState(true);
  const [error, setError] = useState(true);
  const [data, setData] = useState({});

  let navigate = useNavigate();
  const { proposerNum } = useParams();

  console.log(proposerNum);
  console.log("policyData", policyData);

  console.log(proposerNum);
  console.log("policyData", policyData);

  const renderComp = (policyData) => {
    switch (policyData.policyStatus) {
      case 3:
        if (!policyData.policyNumber) {
          return <PolicyNum />;
        } else {
          return <SuccesStatus data={policyData} />;
        }
      case 5:
        return (
          <LoadingStatus status={5} data={data} proposerNum={proposerNum} />
        );
      case 6:
        return (
          <LoadingStatus status={6} data={data} proposerNum={proposerNum} />
        );
      case 4:
        return (
          <LoadingStatus status={4} data={data} proposerNum={proposerNum} />
        );
    }
  };

  useEffect(() => {
    setPolicyData({ policyStatus: 3 });
    let domain;
    if (window.location.hostname.trim() === "localhost") {
      //setPolicyData({ 'policyStatus': 3 })
      domain = process.env.REACT_APP_LOCAL_DJANGO;
    } else if (window.location.hostname.trim() === "it.acuvisor.com") {
      domain = process.env.REACT_APP_PRODUCTION_DJANGO;
    } else {
      domain = process.env.REACT_APP_UAT_DJANGO;
    }
    console.log("domain", domain);
    Axios.get(
      `${domain}/api/health-insurance/care/policy-status?proposalNum=${proposerNum}`
    )
      .then((response) => {
        console.log(response.data);
        setPolicyData(response.data);

        switch (response.data.policyStatus) {
          case 3:
            setData(response.data);
            setLoading(false);
            setRejectPolicy(false);
            setError(false);
            setPolicyDeclined(false);
            return;
          case 5:
            setData(response.data);
            setLoading(true);
            setError(false);
            setRejectPolicy(false);
            setPolicyDeclined(false);

            return;
          case 6:
            setRejectPolicy(false);
            setLoading(false);
            setError(false);
            setPolicyDeclined(true);

            return;
          case 4:
            setRejectPolicy(true);
            setLoading(false);
            setError(false);
            setPolicyDeclined(false);

            return;
        }
      })
      .catch((error) => {
        //alert('Service Not Available')
        console.log(error);
        //console.log(error.status)
      });
  }, []);

  /*  if (loading && error && rejectPolicy) {
       return (
         <LoadingStatus status={5} data={data} proposerNum={proposerNum} />
       );
     case 6:
       return (
         <LoadingStatus status={6} data={data} proposerNum={proposerNum} />
       );
     case 4:
       return (
         <LoadingStatus status={4} data={data} proposerNum={proposerNum} />
       );
   }
 };

 useEffect(() => {
   setPolicyData({ policyStatus: 3 });

   if (window.location.hostname === "localhost") {
     //setPolicyData({ 'policyStatus': 3 })

     Axios.get(
       `http://127.0.0.1:8000/api/health-insurance/care/policy-status?proposalNum=${proposerNum}`
     )
       .then((response) => {
         console.log("ss", response);
       })
       .catch((error) => {
         setError(true);
         console.log(error);
       });
   } else {
     Axios.get(
       `http://65.0.70.70:8000/api/health-insurance/care/policy-status?proposalNum=${proposerNum}`
     )
       .then((response) => {
         console.log(response.data);

         switch (response.data.policyStatus) {
           case 3:
             setData(response.data);
             setLoading(false);
             setRejectPolicy(false);
             setError(false);
             setPolicyDeclined(false);
             return;
           case 5:
             setData(response.data);
             setLoading(true);
             setError(false);
             setRejectPolicy(false);
             setPolicyDeclined(false);

             return;
           case 6:
             setRejectPolicy(false);
             setLoading(false);
             setError(false);
             setPolicyDeclined(true);

             return;
           case 4:
             setRejectPolicy(true);
             setLoading(false);
             setError(false);
             setPolicyDeclined(false);

             return;
         }
       })
       .catch((error) => {
         //alert('Service Not Available')
         console.log(error);
         //console.log(error.status)
       });
   }
 }, []);

 return <>{policyData && renderComp(policyData)}</>;*/
};

export default HealthInsPolicyStatus;
